import { axiosApp } from "../../../utils/appAxios";
const API_URL = process.env.VUE_APP_API;
const moduleWatchSignalR = {
  state: () => ({
    appList: [],
    //signalR
    watchListData: {},

  }),
  mutations: {
    setAppList(state, _apps) {
      state.appList = _apps;
    },
    //signalr
    setWatchListData(state, _watchList) {
      // const index=state.watchListData.findIndex((el) => el.id === _watchList.id);
      // if(index !== -1){
      //   state.watchListData.splice(index,1);
      // }
      // _watchList.nowDate=new Date();
      // state.watchListData.push(_watchList);
      state.watchListData = _watchList;
    },
    clearWatchList(state) {
      state.watchListData = [];
    }
  },
  actions: {
    getAppList({ commit }) {
       axiosApp
        .get(`/AppProcess/ListAppProcess`)
        .then(
          (response) => {
            commit("setAppList", response.data);
          }
        );
    },
  },
  getters: {
    getAppListData(state) {
      return state.appList;
    },
    //signalr
    getWatchList(state) {
      return state.watchListData;
    },

  }
};

export default moduleWatchSignalR;



// WEBPACK FOOTER //
// ./src/store/Modules/watch/index.js